import { connectedComponent } from 'utils/redux/providerWrapper';
import { CartIcon } from './cart_icon';

export const ConnectedCartIcon = connectedComponent(CartIcon);

export default CartIcon;
